import React, { useEffect } from "react";
import Logo from "../../../components/common/logo/Logo";
import {
  Button,
  Container,
  Group,
  PasswordInput,
  Space,
  Text,
  Box,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import applicationComander from "../../../store/commanders/application.comander";
import navigationService from "../../../services/navigation/navigation.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { validateEmail } from "../../../helpers/form.validators";
import { faLongArrowAltLeft, faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@fortawesome/fontawesome-svg-core";
const ResetPasswordPage = (props) => {
  const onSubmit = (data) => {
    applicationComander.cmd_forgot_password_submit(
      data.userName,
      data.resetCode,
      data.confirmPassword
    );
  };

  // Get userName from navigation state (passed from forgot password flow)
  const userName = props.location?.state?.userName || "";

  const form = useForm({
    initialValues: {
      userName: userName,
      password: "",
      confirmPassword: "",
      resetCode: "",
    },

    validate: {
      userName: validateEmail,
      confirmPassword: (value, values) =>
        value !== values.password ? "Passwords did not match" : null,
    },
  });
  return (
    <div>
      <div className="auth-container-box">
        <Box className="auth-single-form">
          <FontAwesomeIcon
            icon={faCircleUser as Icon}
            size={"5x"}
            className="auth-icon"
          />
          <Text className="auth-title" style={{fontSize: '2rem'}}>Reset Password</Text>
          <Text className="auth-description">
            Enter your new password and reset code.
          </Text>
          <form
            onSubmit={form.onSubmit((values) => onSubmit(values))}
            className="u-w-100"
          >
            <TextInput
              mt="sm"
              required
              label="Email"
              placeholder="your@email.com"
              {...form.getInputProps("userName")}
            />
            <PasswordInput
              mt="sm"
              required
              label="New Password"
              placeholder="Enter new password"
              {...form.getInputProps("password")}
            />
            <PasswordInput
              mt="sm"
              required
              label="Confirm Password"
              placeholder="Confirm new password"
              {...form.getInputProps("confirmPassword")}
            />
            <TextInput
              mt="sm"
              required
              label="Reset Code"
              placeholder="Enter reset code"
              {...form.getInputProps("resetCode")}
            />
            <Space h="md" />
            <Group mt="lg" mb="sm">
              <Button size="lg" type="submit" className="u-w-100 auth-submit-button">
                RESET PASSWORD
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="u-w-100 mobile-auth-button"
                onClick={() => navigationService.navigate(URL_PATHS.LOGIN)}
              >
                BACK TO LOGIN
              </Button>
            </Group>
            <Space h={"sm"}></Space>
            <Text
              size="sm"
              align="left"
              className="auth-link"
              onClick={() => navigationService.navigate(URL_PATHS.LOGIN)}
            >
              <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} />
              <span className="u-ml-sm">Back to Log In</span>
            </Text>
          </form>
        </Box>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
